import { NotificationPermissionState } from "@types";

export function getNotificationPermission(): NotificationPermissionState {
  if (typeof window === "undefined") return NotificationPermissionState.DENIED;
  if (typeof Notification === "undefined") return NotificationPermissionState.DENIED;
  return Notification.permission as NotificationPermissionState;
}

export function isNotificationSupported(): boolean {
  return typeof window !== "undefined" && typeof Notification !== "undefined";
}
